import React, { useContext } from "react";
import { Form, Formik } from "formik";
import { defaultValues } from "./default-values";
import { NAME, EMAIL, MESSAGE } from "./field-names";
import AuthContext from "../../../services/firebase/auth-context/provider";
import { validationSchema } from "./validation-schema";
import FormSubmit from "../common/submit";
import { ErrorMessage, Field } from "formik";
var ContactForm = function ContactForm(_ref) {
    var onSubmit = _ref.onSubmit;
    var _useContext$ = useContext(AuthContext)[0], user = _useContext$.user, authenticated = _useContext$.authenticated; // Set email
    if (authenticated && user.email)
        defaultValues["email"] = user.email;
    return /*#__PURE__*/ React.createElement(Formik, {
        onSubmit: onSubmit,
        initialValues: defaultValues,
        validationSchema: validationSchema
    }, function (props) {
        return /*#__PURE__*/ React.createElement(Form, null, /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-wrap my-4"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "w-full md:w-1/2 md:pr-2"
        }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
            className: "label"
        }, "Ihr Name"), /*#__PURE__*/ React.createElement(Field, {
            type: "text",
            name: NAME,
            className: "text-field"
        })), /*#__PURE__*/ React.createElement(ErrorMessage, {
            name: NAME,
            component: "div",
            className: "error-message"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "w-full md:w-1/2 md:pl-2"
        }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
            className: "label"
        }, "Ihre E-Mail Adresse"), /*#__PURE__*/ React.createElement(Field, {
            type: "text",
            name: EMAIL,
            className: "text-field"
        })), /*#__PURE__*/ React.createElement(ErrorMessage, {
            name: EMAIL,
            component: "div",
            className: "error-message"
        }))), /*#__PURE__*/ React.createElement("div", {
            className: "mb-4"
        }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
            className: "label"
        }, "Ihre Nachricht"), /*#__PURE__*/ React.createElement(Field, {
            as: "textarea",
            name: MESSAGE,
            className: "w-full px-3 py-2 bg-gray-300 h-20"
        })), /*#__PURE__*/ React.createElement(ErrorMessage, {
            name: MESSAGE,
            component: "div",
            className: "error-message"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "mb-8"
        }, /*#__PURE__*/ React.createElement(FormSubmit, {
            text: /*#__PURE__*/ React.createElement("span", null, "Abschicken"),
            props: props
        })));
    });
};
export default ContactForm;
